import { runAfterBootstrap } from 'owa-delayed-initialization';
import initCalendarMailboxConfiguration from './actions/initCalendarMailboxConfiguration';
// Load initial state needed for options
runAfterBootstrap(function () {
    initCalendarMailboxConfiguration();
});
export { default as saveCalendarMailboxConfiguration, } from './actions/saveCalendarMailboxConfiguration';
export { default as getCalendarConfiguration } from './utils/getCalendarConfiguration';
export { default as initCalendarMailboxConfiguration, } from './actions/initCalendarMailboxConfiguration';
export { default as updateCalendarMailboxConfiguration, } from './actions/updateCalendarMailboxConfiguration';
//# sourceMappingURL=index.js.map